import React from 'react';
import { DataGridRef } from '../types';
export const GridStore = React.createContext<{
  gridRef: DataGridRef | null;
}>({
  gridRef: null,
});
